import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../src/app/environments/environment';
import { ContaFilha as ContaFilhaModel } from '../models/contaFilha.model';

@Injectable({
  providedIn: 'root',
})
export class ContaFilhaService {
  private apiUrl = `${environment.advContabilApi}/api/contaFilha`;

  constructor(private http: HttpClient) {}

  listaContasFilhas(): Observable<ContaFilhaModel[]> {
    return this.http.get<ContaFilhaModel[]>(`${this.apiUrl}/listar`);
  }

  obterContaFilha(contaFilhaId: any): Observable<ContaFilhaModel> {
    return this.http.get<ContaFilhaModel>(`${this.apiUrl}/obter/${contaFilhaId}`);
  }

  addContaFilha(contaFilha: ContaFilhaModel): Observable<void> {
    return this.http.post<void>(`${this.apiUrl}/inserir`, contaFilha);
  }

  updateContaFilha(contaFilha: ContaFilhaModel): Observable<void> {
    return this.http.put<void>(
      `${this.apiUrl}/atualizar/${contaFilha.id}`,
      contaFilha
    );
  }

  deleteContaFilha(id: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/deletar/${id}`);
  }
}
